module.exports = __webpack_public_path__ + "media/images/icons/filled/plus-circle-7a434633986dd6590eb47ac99e4310eb.svg";